import {
  Autocomplete,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormEditSubCategory = ({
  data,
  setData,
  categories,
  isCategoriesLoading,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const itemsPerPage = 25;
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  // Category States
  const [categoriesPage, setCategoriesPage] = useState(1);
  const [categorySearchQuery, setCategorySearchQuery] = useState("");
  const paginatedCategories = categories.slice(
    0,
    categoriesPage * itemsPerPage
  );
  const filteredCategories = categories.filter((category) =>
    category.name.toLowerCase().includes(categorySearchQuery.toLowerCase())
  );
  const displayedCategories = categorySearchQuery
    ? filteredCategories
    : paginatedCategories;

  const handleCategoryChange = (event, value) => {
    console.log(data);
    setData((prev) => ({ ...prev, category_id: value?.id || "" }));
  };
  // Handle input changes
  const handleInputChange = (e) => {
    console.log(data);
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.SubCategories.Edit + id,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/SubCategories");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Name"
          name="name"
          required
          type="name"
          autoComplete="off"
          value={data.name}
          onChange={handleInputChange}
          variant="outlined"
        />
        <div className="w-full">
          <Autocomplete
            disablePortal
            loading={isCategoriesLoading}
            options={displayedCategories}
            getOptionLabel={(option) => option.name || ""}
            onChange={handleCategoryChange}
            onInputChange={(event, value) => setCategorySearchQuery(value)}
            renderInput={(params) => (
              <TextField {...params} label="Category" variant="outlined" />
            )}
            ListboxProps={{
              onScroll: (event) => {
                const listboxNode = event.currentTarget;
                if (
                  listboxNode.scrollTop + listboxNode.clientHeight >=
                  listboxNode.scrollHeight - 3
                ) {
                  setCategoriesPage((prevPage) => prevPage + 1);
                }
              },
            }}
          />
        </div>
      </div>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
